/**
 * Map
 */

import $ from 'jquery';
import Page from '~/page/page';

export default class Map extends Page {
  init() {
    this.param = {};

    this.elements({
      container: '.js-map-container'
    });

    $.getScript(
      '//maps.googleapis.com/maps/api/js?key=AIzaSyCGp6pOLSkRpcCD_AGJ4c9dlRZaHcuT9gs',
      () => {
        this.setParams();
        google.maps.event.addDomListener(window, 'load', () => this.setMap());
      }
    );
  }
  setParams() {
    const data = this.$.root.data('options');

    this.markers = data.markers;
    this.param.center = data.center;
    this.param.zoom = data.zoom;
  }
  setMap() {
    const options = {
      zoom: this.param.zoom,
      scrollwheel: false,
      center: new google.maps.LatLng(...this.param.center),
      disableDefaultUI: true,
      zoomControl: true,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#7c7c7c'
            }
          ]
        },
        {
          featureType: 'administrative.locality',
          elementType: 'all',
          stylers: [
            {
              hue: '#0049ff'
            },
            {
              saturation: 7
            },
            {
              lightness: 19
            },
            {
              visibility: 'on'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              hue: '#ff0000'
            },
            {
              saturation: -100
            },
            {
              lightness: 100
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#999999'
            },
            {
              visibility: 'on'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              hue: '#ff0000'
            },
            {
              saturation: -100
            },
            {
              lightness: 100
            },
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#ebebeb'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#c2c2c2'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              hue: '#bbc0c4'
            },
            {
              saturation: -93
            },
            {
              lightness: 31
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels',
          stylers: [
            {
              saturation: -93
            },
            {
              lightness: 31
            },
            {
              visibility: 'on'
            },
            {
              hue: '#008eff'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#565656'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels',
          stylers: [
            {
              hue: '#bbc0c4'
            },
            {
              saturation: -93
            },
            {
              lightness: -2
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#2a2a2a'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              hue: '#e9ebed'
            },
            {
              saturation: -90
            },
            {
              lightness: -8
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            {
              hue: '#e9ebed'
            },
            {
              saturation: 10
            },
            {
              lightness: 69
            },
            {
              visibility: 'on'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              saturation: -78
            },
            {
              lightness: 67
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#e4e4e4'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#969696'
            }
          ]
        }
      ]
    };

    this.map = new google.maps.Map(this.$.container.get(0), options);
    this.generateMarkers();
  }
  generateMarkers() {
    this.markers.forEach(marker => {
      this.setMarker(
        marker.title,
        marker.coords,
        {
          url: marker.image,
          size: new google.maps.Size(32, 64),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(16, 60),
          scaledSize: new google.maps.Size(32, 64)
        },
        marker
      );
    });
  }
  setMarker(title, coords, icon, data) {
    new google.maps.Marker({
      position: new google.maps.LatLng(...coords),
      map: this.map,
      icon,
      optimized: false,
      title
    });
  }
}
Page.mount(Map, '.js-map');
